import React from "react";
import Loadable from "react-loadable";
import MediaQuery from "react-responsive";

import "../../styles/header.css";
import logo from "../../images/logo.svg";
import { AsynLoader } from "../Loader/AsynLoader";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNavBar: false,
      showSearchPanel: false
    };
  }

  handleNavBar = () => {
    this.setState(prev => ({ showNavBar: !prev.showNavBar }));
  };

  handleSearchPanel = e => {
    e.stopPropagation();
    this.setState(prev => ({ showSearchPanel: !prev.showSearchPanel }));
  };

  render() {
    return (
      <header className="t-container-fluid header">
        <div className="trodly__logo">
          <a href="/">
            <img src={logo} alt="Trodly Logo" />
          </a>
        </div>
        <div className="trodly__header_tools">
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <div className="trodly__search">
                    <div className="trodly__search__icon" onClick={this.handleSearchPanel} />
                    <div className={`trodly__search_container`}>
                      {this.state.showSearchPanel && (
                        <AsynSearchPanel
                          handleSearchPanel={this.handleSearchPanel}
                          in={this.state.showSearchPanel}
                        />
                      )}
                    </div>
                  </div>
                );
              } else {
                return <AsynDesktopSearchPanel />;
              }
            }}
          </MediaQuery>
          <MediaQuery maxWidth={900}>
            {matches => {
              if (matches) {
                return (
                  <div className="trodly__navbar">
                    <div className="trodly_hamburger__icon" onClick={this.handleNavBar} />
                    <div className={`trodly__search_container`}>
                      {this.state.showNavBar && (
                        <AsynNavbar in={this.state.showNavBar} handleNavBar={this.handleNavBar} />
                      )}
                    </div>
                  </div>
                );
              } else {
                return <AsynDesktopNavbar />;
              }
            }}
          </MediaQuery>
        </div>
      </header>
    );
  }
}

const AsynSearchPanel = Loadable({
  loader: () => import("./MobileSearchPanel"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const AsynNavbar = Loadable({
  loader: () => import("./MobileNavBar"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const AsynDesktopSearchPanel = Loadable({
  loader: () => import("./DesktopSearch"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const AsynDesktopNavbar = Loadable({
  loader: () => import("./DesktopNavbar/NavBar"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});
export default Header;
